"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithRelayFeature = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function WithRelayFeature(Base) {
    return /** @class */ (function (_super) {
        __extends(RelayFeature, _super);
        function RelayFeature() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, __spreadArray([], __read(args), false)) || this;
            _this.inRelay = function (_a) {
                var from = _a.from, body = __rest(_a, ["from"]);
                if (!from || body.data === undefined)
                    return;
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                var sender = _this.createRef(from);
                _this.router.emit('relay', [sender, body.data, Array.isArray(body.to) ? body.to : [body.to]]);
            };
            _this.pod.receive('notify_relay', _this.inRelay);
            return _this;
        }
        RelayFeature.prototype.sendRelay = function (to, data, reductionKey) {
            if (this.readonly || this.destroyed())
                return;
            this.pod.send('relay', { to: to, data: data }, reductionKey);
        };
        RelayFeature.prototype.on = function (type, to) {
            return this.router.on(type, to);
        };
        return RelayFeature;
    }(Base));
}
exports.WithRelayFeature = WithRelayFeature;
